import { endsWith, getOr } from 'lodash/fp';
import { createBrowserHistory } from 'history';
import config from './config';

const isMandi = getOr(false, 'attributes.isMandi');

export const getDesignUrl = (design) => {
  const mode = isMandi(design) ? 'mandi' : 'chuck';
  return `${config.estimatebuilderBasePaths[mode]}${config.estimatebuilderLoadPath}/${design.designId}`;
};

const updateEstimateURL = (design) => {
  const history = createBrowserHistory();
  const { location } = history;

  if (!design) {
    return;
  }

  const mode = isMandi(design) ? 'mandi' : 'chuck';
  const estimatePath = getDesignUrl(design);

  if (location.pathname !== estimatePath) {
    if (endsWith('new')(location.pathname)) {
      history.replace(estimatePath);
      window.location.reload();
    } else {
      history.push(estimatePath);
    }
    if (mode !== config.estimatebuilderMode) {
      window.location.reload();
    }
  }
};

export default updateEstimateURL;
